var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.element.hasChildren)?_c('div',[_c('subcomponents',{style:(_vm.customStyle),attrs:{"isEditable":_vm.isEditable,"componenti":_vm.element.items,"children":_vm.element.hasChildren},on:{"updateComp":function (data) {
				_vm.element.items = data
			}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }